import { useContext } from "react";
import { CombinedIncomeContext } from "./CombinedIncomeProvider";

export const useCombinedIncomeContext = () => {
  const context = useContext(CombinedIncomeContext);
  if (!context)
    throw new Error(
      "useCombinedIncomeContext must be used within CombinedIncomeProvider"
    );
  return context;
};
